"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSON_SURVEYSPECIFICDATA_KEYNAME = exports.JSON_SURVEYSTRINGS_KEYNAME = exports.JSON_EXTENDEDMANIFESTDATA_KEYNAME = exports.JSON_APPLICATION_KEYNAME = exports.JSON_MULTIPLECHOICE_KEYNAME = exports.JSON_QUESTION_KEYNAME = exports.JSON_TITLE_KEYNAME = exports.JSON_CVSURVEYPLATFORM_KEYNAME = exports.JSON_CVSURVEYUIHOST_KEYNAME = exports.JSON_CVSURVEYPRODUCTNAME_KEYNAME = exports.JSON_RATINGOPTIONS_KEYNAME = exports.JSON_CVSURVEYTHEME_KEYNAME = exports.JSON_CVSURVEYFORMID_KEYNAME = exports.JSON_CVSURVEY_KEYNAME = exports.JSON_RATING_KEYNAME = exports.JSON_COMMENT_KEYNAME = exports.JSON_PROMPTNOTEXT_KEYNAME = exports.JSON_PROMPTYESTEXT_KEYNAME = exports.JSON_PROMPT_KEYNAME = exports.JSON_INTERCEPTURL_KEYNAME = exports.JSON_INTERCEPT_KEYNAME = exports.DOM_MULTIPLECHOICE_TAGNAME = exports.DOM_CVSURVEY_TAGNAME = exports.DOM_RATING_TAGNAME = exports.DOM_COMMENT_TAGNAME = exports.DOM_PROMPT_TAGNAME = void 0;
exports.DOM_PROMPT_TAGNAME = "Prompt";
exports.DOM_COMMENT_TAGNAME = "Comment";
exports.DOM_RATING_TAGNAME = "Rating";
exports.DOM_CVSURVEY_TAGNAME = "CVSurvey";
exports.DOM_MULTIPLECHOICE_TAGNAME = "MultipleChoice";
exports.JSON_INTERCEPT_KEYNAME = "intercept";
exports.JSON_INTERCEPTURL_KEYNAME = "url";
exports.JSON_PROMPT_KEYNAME = "prompt";
exports.JSON_PROMPTYESTEXT_KEYNAME = "yesButtonText";
exports.JSON_PROMPTNOTEXT_KEYNAME = "noButtonText";
exports.JSON_COMMENT_KEYNAME = "comment";
exports.JSON_RATING_KEYNAME = "rating";
exports.JSON_CVSURVEY_KEYNAME = "cvSurvey";
exports.JSON_CVSURVEYFORMID_KEYNAME = "formId";
exports.JSON_CVSURVEYTHEME_KEYNAME = "theme";
exports.JSON_RATINGOPTIONS_KEYNAME = "options";
exports.JSON_CVSURVEYPRODUCTNAME_KEYNAME = "productName";
exports.JSON_CVSURVEYUIHOST_KEYNAME = "uiHost";
exports.JSON_CVSURVEYPLATFORM_KEYNAME = "platform";
exports.JSON_TITLE_KEYNAME = "title";
exports.JSON_QUESTION_KEYNAME = "question";
exports.JSON_MULTIPLECHOICE_KEYNAME = "multipleChoice";
exports.JSON_APPLICATION_KEYNAME = "application";
exports.JSON_EXTENDEDMANIFESTDATA_KEYNAME = "extendedManifestData";
exports.JSON_SURVEYSTRINGS_KEYNAME = "surveyStrings";
exports.JSON_SURVEYSPECIFICDATA_KEYNAME = "surveySpecificData";
